import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateVolumePoolMutationVariables = Types.Exact<{
  input: Types.CreateVolumePoolInput;
}>;


export type CreateVolumePoolMutation = { __typename?: 'Mutation', createVolumePool: { __typename?: 'VolumePoolPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, volumePool?: { __typename?: 'VolumePoolStateData', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus } | null } };

export type ReactivateVolumePoolMutationVariables = Types.Exact<{
  input: Types.ReactivateVolumePoolInput;
}>;


export type ReactivateVolumePoolMutation = { __typename?: 'Mutation', reactivateVolumePool: { __typename?: 'VolumePoolPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, volumePool?: { __typename?: 'VolumePoolStateData', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus } | null } };


export const CreateVolumePoolDocument = new TypedDocumentString(`
    mutation CreateVolumePool($input: CreateVolumePoolInput!) {
  createVolumePool(input: $input) {
    errors {
      code
      message
    }
    volumePool {
      id
      volumePoolId
      code
      name
      quantityBasis
      status
    }
  }
}
    `);
export const ReactivateVolumePoolDocument = new TypedDocumentString(`
    mutation ReactivateVolumePool($input: ReactivateVolumePoolInput!) {
  reactivateVolumePool(input: $input) {
    errors {
      code
      message
    }
    volumePool {
      id
      volumePoolId
      code
      name
      quantityBasis
      status
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateVolumePool: build.mutation<CreateVolumePoolMutation, CreateVolumePoolMutationVariables>({
      query: (variables) => ({ document: CreateVolumePoolDocument, variables })
    }),
    ReactivateVolumePool: build.mutation<ReactivateVolumePoolMutation, ReactivateVolumePoolMutationVariables>({
      query: (variables) => ({ document: ReactivateVolumePoolDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateVolumePoolMutation, useReactivateVolumePoolMutation } = injectedRtkApi;
